<template>
  <component :is="handComponent" :data="data"></component>
</template>

<script>
import hands from '@/components/parts/hands';

export default {
  name: 'sdHand',
  props: ['data'],
  components: {
    ...hands,
  },
  data() {
    return {
      hands,
    };
  },
  computed: {
    hand() {
      if (this.data.hand) return this.data.hand;
    },
    wristwatch() {
      if (this.data.wristwatch) return this.data.wristwatch;
    },
    handComponent() {
      if (this.hand && this.wristwatch) {
        return this.hands[this.wristwatch.movement][this.hand.role];
      }
    },
  },
  mounted() {
    this.$emit('initialize-component', { component: this.hand, element: this.$el });
  },
};
</script>
